import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutProviderQuickInfo } from "./autogen/AutogenLayoutProviderQuickInfo";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class ProviderQuickInfo extends AutogenLayoutProviderQuickInfo {

    /** This is an event handler for the afterExecution event of sourceFuelInterfaceLookup. */
    sourceFuelInterfaceLookupAfterExecution(event: DataSourceExecutionEvent) {
        this.textboxId.printableLabel.link = LayoutUrl.create("lme/integrations/IntegrationHub", {
            fuelVendor: event.data?.get("id")
        });
    }

}
